module.exports = __webpack_public_path__ + "img/116.7.565261db.png";